// Material UI
import { makeStyles } from '@material-ui/styles'
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  description: {},
  switchRoot: {
    justifySelf: 'end',
  },
  textContainer: {
    display: 'grid',
    gridAutoColumns: 'auto',
    gridAutoFlow: 'row',
    gridAutoRows: 'min-content',
    gridRowGap: 6,
  },
  title: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 17,
    fontWeight: 'bold',
  },
  root: {
    alignContent: 'center',
    backgroundColor: Colors.WHITE,
    color: Colors.SECONDARY_FONT_COLOR,
    display: 'grid',
    fontSize: 13,
    gridAutoFlow: 'row',
    gridAutoRows: 'min-content',
    gridRowGap: 17,
    lineHeight: 'normal',
    padding: 24,
    border: `1px solid ${Colors.DISABLED_COLOR}`,
    [theme.breakpoints.up('md')]: {
      border: `1px solid ${Colors.DISABLED_COLOR}`,
      gridColumnGap: 24,
      gridTemplateColumns: 'auto min-content',
      margin: '24px 24px 0px 24px',
    },
  },
}))
